<script setup>
  import {computed, ref} from "vue";

  const props = defineProps({
    data: {
      type: Array,
      required: true,
    },
    color: {
      required: false,
      type: String,
      default: '#0094FF',
    },
    withBackgroundGradient: {
      required: false,
      type: Boolean,
      default: false,
    },
  });

  const series = computed(() => {
    return [{
      data: props.data.slice().reverse(),
    }];
  })

  const chartOptions = ref({
    chart: {
      type: props.withBackgroundGradient ? 'area' : 'line',
      width: '100%',
      zoom: {
        enabled: false
      },
      selection: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
      redrawOnParentResize: true,
    },
    colors: [props.color],
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    xaxis: {
      labels: {
        show: false,
      },
    },
    yaxis: {
      reversed: true,
      labels: {
        show: false,
      },
    },
    grid: {
      padding: {
        top: 30,
        right: 0,
        bottom: 30,
        left: 0,
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        opacityFrom: 0,
        opacityTo: 0,
      },
    },
    tooltip: {
      enabled: false,
    },
  });
</script>

<template>
  <apexchart
    height="90%"
    :options="chartOptions"
    :series="series"
  />
</template>

